/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_RemainingInputs */

const en_admin_credits_remaining = /** @type {(inputs: Admin_Credits_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remaining`)
};

const zh_admin_credits_remaining = /** @type {(inputs: Admin_Credits_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剩余`)
};

/**
* | output |
* | --- |
* | "Remaining" |
*
* @param {Admin_Credits_RemainingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_remaining = /** @type {((inputs?: Admin_Credits_RemainingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_RemainingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_remaining(inputs)
	return zh_admin_credits_remaining(inputs)
});
export { admin_credits_remaining as "admin.credits.remaining" }